import { useState } from "react";
import { useTranslation } from "react-i18next";
import OfferList from "../../../../assets/TakyonDesignSystem/components/Offer/OfferList";

export default function OffersReceived() {
  const { t } = useTranslation();
  const [showExpired, setShowExpired] = useState(false);

  return (
    <div id="offers-received">
      {/* offerte received */}
      <OfferList side="seller" />
      <hr />
      <div className="d-flex justify-content-end">
        <a
          className="text-underline black-color"
          onClick={() => {
            setShowExpired(!showExpired);
          }}
        >
          {t(!showExpired ? "generic.show" : "generic.hide")}{" "}
          {t("offers.received.showExpired")}
        </a>
      </div>
      {showExpired && <OfferList side="seller" expired={true} />}
    </div>
  );
}
